import type { LyricInput } from '@creanizer/types'
import { Card } from '@creanizer/ui'
import { Button } from '@creanizer/ui'
import { Sparkles } from 'lucide-react'
import { QuickInput } from './QuickInput'
import { LyricFormDetailed } from './LyricFormDetailed'

interface LyricFormProps {
  input: LyricInput
  onChange: (input: LyricInput) => void
  onGenerate: () => void
  isGenerating: boolean
  inputMode: 'quick' | 'detailed'
  onInputModeChange: (mode: 'quick' | 'detailed') => void
}

export function LyricForm({
  input,
  onChange,
  onGenerate,
  isGenerating,
  inputMode,
  onInputModeChange
}: LyricFormProps) {
  const handleModeChange = (mode: 'quick' | 'detailed') => {
    onInputModeChange(mode)
    if (mode === 'quick') {
      // クイックモードの場合、すべてを自動に設定
      onChange({
        ...input,
        mode: mode,
        genre: 'auto',
        language: 'auto',
        structure: 'auto',
        creativityLevel: 'auto'
      })
    } else {
      // 詳細モードの場合
      onChange({
        ...input,
        mode: mode
      })
    }
  }

  return (
    <Card className="p-6">
      <div className="space-y-6">
        {/* モード切り替え */}
        <div className="flex gap-2 mb-4">
          <Button
            variant={inputMode === 'quick' ? 'default' : 'outline'}
            size="sm"
            onClick={() => handleModeChange('quick')}
          >
            🚀 クイック入力
          </Button>
          <Button
            variant={inputMode === 'detailed' ? 'default' : 'outline'}
            size="sm"
            onClick={() => handleModeChange('detailed')}
          >
            ⚙️ 詳細設定
          </Button>
        </div>

        {/* 入力エリア */}
        {inputMode === 'quick' ? (
          <QuickInput input={input} onChange={onChange} />
        ) : (
          <LyricFormDetailed input={input} onChange={onChange} />
        )}

        {/* 生成ボタン */}
        <div className="flex justify-end pt-4 border-t">
          <Button
            onClick={onGenerate}
            disabled={isGenerating || (!input.quickPrompt && inputMode === 'quick')}
            className="min-w-[150px]"
          >
            {isGenerating ? (
              <>生成中...</>
            ) : (
              <>
                <Sparkles className="mr-2 h-4 w-4" />
                歌詞を生成
              </>
            )}
          </Button>
        </div>
      </div>
    </Card>
  )
}